import ErrorFilled from '@/public/icons/error-filled.svg';
import SuccessFilled from '@/public/icons/success-filled.svg';
import WaitingFilled from '@/public/icons/waiting-filled.svg';
import WarningFilled from '@/public/icons/warning-filled.svg';
import classes from '@/storyblok/orderStatus/OrderStatus.module.scss';
import type { PartialOrderStatusStepStoryblok } from '@/types/component-types-sb';
import classNames from 'classnames';

export type OrderStatusStepProps = Pick<PartialOrderStatusStepStoryblok, 'heading' | 'text' | 'status'>;

const OrderStatusStep: React.FC<OrderStatusStepProps> = (props) => {
  let icon = <ErrorFilled />;
  switch (props.status) {
    case 'success':
      icon = <SuccessFilled />;
      break;
    case 'warning':
      icon = <WarningFilled />;
      break;
    case 'waiting':
      icon = <WaitingFilled />;
      break;
    default:
      icon = <ErrorFilled />;
      break;
  }

  return (
    <div
      className={classNames(classes.step, {
        success: props.status === 'success',
        warning: props.status === 'warning',
        waiting: props.status === 'waiting',
        error: props.status === 'error' || !Boolean(props.status),
      })}
    >
      <div className={classes.connectorContainer}>
        <div className={classes.connector} />
      </div>
      <div className={classes.pill}>
        <div className={classes.icon}>
          <div className={classes.svgWrapper} aria-hidden>
            {icon}
          </div>
        </div>
        <div className={classes.textContainer}>
          <div className={classes.heading}>{props.heading}</div>
          <p className={classes.text}>{props.text}</p>
        </div>
      </div>
    </div>
  );
};
export default OrderStatusStep;
